module.exports = __webpack_public_path__ + "static/media/imageMarker.29bba1fe.svg";